// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"SkeletonLoading_skeleton__Az_Rm","shine":"SkeletonLoading_shine__TJk_U"};